$shm_hitalama_footer $mol_view
	logo_uri \/shm/hitalama/footer/foot_logo_light.png
	sub /
		<= Label $mol_paragraph
			title \разработано в
		<= Logo $mol_image
			uri <= logo_uri
		<= Version $shm_hitalama_version_label
			version <= version \0.0.24
			date <= date \06.07.2026
